import { createContext } from 'react';
import { SpacingName } from '../../theme';
export const GridContext = /*#__PURE__*/createContext({
  gutter: SpacingName.SMALLER,
  wrap: false
});
//# sourceMappingURL=GridContext.js.map